import { MaskLine } from "@/components/Reveal";

const CONTENT = {
  "Privacy Policy": [
    { h: "What We Collect", p: "When you submit an enquiry or your resume through this website, we collect the details you provide — such as your name, contact information, company, and message — solely to respond to your request." },
    { h: "How We Use It", p: "Your information is used only for recruitment and staffing communication between you and Genspire. We do not sell or share your personal information with third parties for marketing purposes." },
    { h: "Data Retention", p: "We retain submissions only as long as needed to serve the purpose they were provided for, or as required by applicable law. You may request deletion of your data at any time by contacting us." },
  ],
  "Terms & Conditions": [
    { h: "Use of This Website", p: "This website provides information about Genspire's staffing and recruitment services. Content is provided for general information and does not constitute a binding offer of employment or placement." },
    { h: "Enquiries & Submissions", p: "Submitting an enquiry or resume does not create a contractual relationship. Any engagement with Genspire is governed by a separately agreed service agreement." },
    { h: "Intellectual Property", p: "The Genspire name, logo, and website content are the property of Genspire and may not be reproduced without written permission." },
  ],
};

export default function Legal({ title }) {
  const sections = CONTENT[title] || [];
  return (
    <section className="pt-[140px] pb-20" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <MaskLine delay={0.05}>
          <span className="flex items-center gap-4">
            <span className="h-px w-12 bg-brand-red" />
            <span className="font-mono text-[11px] uppercase tracking-[0.38em] text-brand-red font-medium">Legal</span>
          </span>
        </MaskLine>
        <h1 className="mt-7 font-display font-extrabold tracking-tight text-slate-900 text-4xl sm:text-5xl">
          <MaskLine delay={0.18}>{title}</MaskLine>
        </h1>
        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-display font-semibold text-slate-900 text-xl">{s.h}</h2>
              <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
